import {ParamMap} from '@angular/router';

export interface CheckoutSelection {
  productId: number;
  variantId: number;
}

export function createCheckoutUrl(
  productId: unknown,
  variantId: unknown,
  tempHash: string | null = null
): string | null {
  const selection = parseSelection(String(productId), String(variantId));

  if (!selection) {
    return null;
  }

  const params = new URLSearchParams({
    productId: String(selection.productId),
    variantId: String(selection.variantId),
  });

  if (tempHash) {
    params.set('temp', tempHash);
  }

  return `/checkout?${params.toString()}`;
}

export function getCheckoutSelection(
  params: ParamMap
): CheckoutSelection | null {
  return parseSelection(params.get('productId'), params.get('variantId'));
}

function parseSelection(
  rawProductId: string | null,
  rawVariantId: string | null
): CheckoutSelection | null {
  const productId = parseId(rawProductId);
  const variantId = parseId(rawVariantId);

  return productId && variantId ? {productId, variantId} : null;
}

function parseId(rawId: string | null): number | null {
  if (!rawId || !/^[1-9]\d*$/.test(rawId)) {
    return null;
  }

  const id = Number(rawId);
  return Number.isSafeInteger(id) ? id : null;
}
